<template>
  <div class="section" style="padding: 20px 20px 10px 20px">
    <el-form :disabled="!isEdit" :inline="true" label-width="80px" label-position="left">
      <!--公司名称-->
      <el-form-item :label="$t('Partners.CompanyName')">
        <cargo-advance-select
          no="companyName"
          :disabled="!isEdit"
          filterable
          :select-type="selectTypeNames.basic_data_Company"
          style="width: 350px;margin-right: 30px"
          @parentCallBack="getValueFromChild"
        />
      </el-form-item>
      <el-form-item label>
        <el-select v-model="filter.serviceType" no="serviceType" style="width: 350px">
          <el-option value="ALL" :label="$t('SeaExport.All')">{{ $t('SeaExport.All') }}</el-option>
          <el-option value="Vendor">Vendor</el-option>
          <el-option value="Middleman" :label="$t('Partners.Middleman')">{{ $t('Partners.Middleman') }}</el-option>
          <el-option value="Factory" :label="$t('Partners.Factory')">{{ $t('Partners.Factory') }}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label>
        <el-button no="search" type="primary" @click="search">{{ $t('Partners.search') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="grid-view">
      <div class="main-content">
        <div class="operations" style="margin-bottom: 5px">
          <div class="triggers">
            <div>
              <el-button no="new" :disabled="!isEdit" type="primary" @click="showAddDialog">{{ $t('common.btn.new') }}</el-button>
              <el-button no="delete" :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
              <el-button no="import" :disabled="!isEdit" type="primary" @click="importTemplate">{{ $t('Partners.import') }}</el-button>
            </div>
          </div>
        </div>
        <div class="grid-wrapper">
          <cargo-ag-grid :grid-params.sync="girdParams" :grid-options="gridOptions" :column-defs="columnDefs" :row-data="rowData" />
        </div>
      </div>
    </div>
    <!-- 新增弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div id="app" class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form v-if="editDialog.visible" label-width="110px" label-position="left">
          <el-form-item :label="$t('Partners.isCustomer')">
            <label>{{ editDialog.chineseName }}</label>
          </el-form-item>
          <el-form-item label="Vendor">
            <cargo-advance-select
              no="tradersSignCompanyList"
              :disabled="!isEdit"
              filterable
              :headers="[$t('Partners.chineseName'),$t('Tool.ShortName')]"
              :fields="['chineseName','shortName']"
              :select-type="selectTypeNames.basic_data_Company"
              :static-options="tradersSignCompanyList"
              :custom-label="companyLabel"
              @parentCallBack="setVendor"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.Middleman')">
            <cargo-advance-select
              no="middleman"
              :disabled="!isEdit"
              filterable
              :method-params="{tradersSign:true}"
              :select-type="selectTypeNames.basic_data_Company"
              :custom-label="companyLabel"
              :headers="[$t('Partners.chineseName'),$t('Tool.ShortName')]"
              :fields="['chineseName','shortName']"
              :static-options="tradersSignCompanyList"
              @parentCallBack="setMiddleman"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.Factory')">
            <cargo-advance-select
              no="factory"
              :disabled="!isEdit"
              filterable
              :method-params="{factorySign:true}"
              :headers="[$t('Partners.chineseName'),$t('Tool.ShortName')]"
              :fields="['chineseName','shortName']"
              :select-type="selectTypeNames.basic_data_Company"
              :custom-label="companyLabel"
              :static-options="factoryCompanyList"
              @parentCallBack="setFactory"
            />
          </el-form-item>
          <span v-if="showTip" style="color: red">{{ $t('Partners.lineAlreadyExistsAndCannotAddedRepeatedly') }}</span>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false;showTip = false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 查看联系方式 -->
    <el-dialog v-el-drag-dialog :visible.sync="bankDialog.visible" :title="$t('Partners.viewContactInformation')" width="1000px" :close-on-click-modal="false">
      <label>{{ $t('Partners.Company') }}:{{ bankDialog.company.chineseName }}</label>
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid :grid-options="bankDialog.gridOptions" :column-defs="bankDialog.columnDefs" :row-data="bankDialog.rowData" />
      </div>
    </el-dialog>
    <import-supply-chain :visible.sync="importDialog.visible" :company-uuid="importDialog.companyUuid" @refresh="search" />
  </div>
</template>

<script>
import titleBankForm from './titleBankForm'
import { loadPartnerFactoryData, checkPartnerFactory } from '@/api/company'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { Company } from '@/class/model/mdm/Company'
import importSupplyChain from '@/views/cargo/v0/Information/components/partner/tab/importSupplyChain'

export default {
  name: 'SupplyChainForm',
  components: { titleBankForm, cargoAdvanceSelect, importSupplyChain },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showTip: false,
      tradersSignCompanyList: [],
      factoryCompanyList: [],
      selectTypeNames: TYPE_NAMES,
      company: new Company().fillDefaultValue().getData(),
      form: {},
      filter: {
        searchKey: '',
        serviceType: 'ALL',
        companyUuid: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '', width: 60, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: 'Vendor',
          field: 'tradersUuid',
          width: 150,
          cellRenderer: params => {
            return this.getPartnerName(params)
          }
        },
        {
          headerName: this.$t('Partners.Middleman'),
          field: 'middlemanUuid',
          width: 150,
          cellRenderer: params => {
            return this.getPartnerName(params)
          }
        },
        {
          headerName: this.$t('Partners.Factory'),
          field: 'factoryUuid',
          width: 150,
          cellRenderer: params => {
            return this.getPartnerName(params)
          }
        }
      ],
      rowData: [],
      deletedPartnerFactoryKeys: [],
      editDialog: {
        visible: false,
        title: '',
        initialForm: null,
        chineseName: '',
        form: {
          uuid: '',
          title: '',
          taxAccount: '',
          address: '',
          telephone: '',
          defaultTitle: false,
          email: '',
          autoSend: false,
          customerUuid: ''
        }
      },
      bankDialog: {
        visible: false,
        company: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('Partners.contacts_name'),
            field: 'contactPerson',
            width: 120
          },
          {
            headerName: this.$t('Partners.contacts_function'),
            field: 'role',
            width: 120
          },
          {
            headerName: this.$t('Partners.contacts_telephone'),
            field: 'telephone',
            width: 120
          },
          {
            headerName: this.$t('Partners.contacts_email'),
            field: 'email',
            width: 150
          },
          {
            headerName: this.$t('Partners.contacts_mobile'),
            field: 'mobile',
            width: 150
          },
          {
            headerName: this.$t('Partners.contacts_remark'),
            field: 'remarks',
            width: 150
          }
        ],
        rowData: []
      },
      importDialog: {
        companyUuid: '',
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    bankDialogVisible() {
      return this.bankDialog.visible
    }
  },
  watch: {
    bankDialogVisible(newVal) {
      if (!newVal) {
        this.gridApi.refreshCells({ force: true })
      }
    }
  },
  created() {
    this.initCompanyList()
  },
  beforeMount() {
    const context = this
    document.titleForm = {
      companyManage(uuid) {
        context.companyManage(uuid)
      }
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.company = row
        this.search()
        this.deletedPartnerFactoryKeys = []
      }
    },
    showAddDialog() {
      this.editDialog.chineseName = this.company.chineseName
      this.editDialog.form = { ...this.editDialog.initialForm }
      this.editDialog.form.companyUuid = this.company.uuid
      this.editDialog.title = this.$t('common.btn.new')
      this.editDialog.visible = true
    },
    async saveSub() {
      const self = this
      const form = self.editDialog.form
      if (!form || !form.tradersUuid) {
        this.$message.info(this.$t('Partners.vendorCannotEmpty'))
        return
      }
      for (const row of this.rowData) {
        if (row.tradersUuid === form.tradersUuid && row.middlemanUuid === form.middlemanUuid && row.factoryUuid === form.factoryUuid) {
          this.showTip = true
          return
        }
      }
      if (this.company.uuid) {
        const loading = getLoading4Cxt(this)
        try {
          const resp = await checkPartnerFactory(form)
          if (resp.data > 0) {
            this.showTip = true
            return
          }
          this.rowData.push(form)
          self.editDialog.visible = false
        } catch {
          self.faultHandler()
        } finally {
          loading.close()
        }
      } else {
        this.rowData.push(form)
        self.editDialog.visible = false
      }
    },
    faultHandler() {
      this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
    },
    async remove() {
      const self = this
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      let t = ' '
      const uuids = []
      const companyList = getFilterCacheList(basicCacheKeys.basic_data_Company)
      for (const row of rows) {
        const tCompany = companyList.find(company => company.uuid === row.tradersUuid)
        const tCompanyName = tCompany ? tCompany.chineseName : ''
        const fCompany = companyList.find(company => company.uuid === row.factoryUuid)
        const fCompanyName = fCompany ? fCompany.chineseName : ''
        t += tCompanyName + ' -> ' + fCompanyName + ' \n '
        if (row.uuid) {
          uuids.push(row.uuid)
        }
      }
      await self.$confirm(t + '\n' + this.$t('Partners.confirmDeleteSupplyChainLine'), this.$t('Partners.deleteSupplyChain'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      })
      for (let i = this.rowData.length - 1; i >= 0; --i) {
        if (rows.includes(this.rowData[i])) {
          this.rowData.splice(i, 1)
        }
      }
      this.deletedPartnerFactoryKeys.push(...uuids)
      self.$message.success(self.$t('common.tips.deleteSuccess'))
    },
    getSubmitData() {
      return {
        partnerFactories: this.rowData,
        deletedPartnerFactoryKeys: this.deletedPartnerFactoryKeys
      }
    },
    importTemplate() {
      this.importDialog.companyUuid = this.company.uuid
      this.importDialog.visible = true
    },
    async companyManage(uuid) {
      const companyList = getFilterCacheList(basicCacheKeys.basic_data_Company)
      const company = companyList.find(company => company.uuid === uuid)
      if (!company) {
        return
      }
      const contacts = await new Company({ uuid }).getContacts()
      this.bankDialog.company = company
      this.bankDialog.rowData = contacts
      this.bankDialog.visible = true
    },
    async search() {
      if (this.company.uuid) {
        this.filter.companyUuid = this.company.uuid
        const loading = getLoading4Cxt(this)
        await loadPartnerFactoryData(this.filter).then(resp => {
          this.rowData = resp.data
        }).finally(() => {
          loading.close()
        })
      } else {
        this.rowData = []
      }
    },
    getPartnerName(params) {
      if (params && params.value) {
        const companyList = getFilterCacheList(basicCacheKeys.basic_data_Company)
        const company = companyList.find(company => company.uuid === params.value)
        if (!company) return ''
        return `<u onclick="document.titleForm.companyManage('` + company.uuid + `')" style="color:#46a6ff;cursor:pointer">` + company.chineseName + `</u>`
      }
      return ''
    },
    getValueFromChild(obj) {
      this.filter.searchKey = obj ? obj.uuid : ''
    },
    setVendor(obj) {
      this.editDialog.form.tradersUuid = obj ? obj.uuid : ''
    },
    setMiddleman(obj) {
      this.editDialog.form.middlemanUuid = obj ? obj.uuid : ''
    },
    setFactory(obj) {
      this.editDialog.form.factoryUuid = obj ? obj.uuid : ''
    },
    companyLabel(data) {
      if (data) {
        console.log('data')
        console.log(data.chineseName + '[' + data.shortName + ']')
        return `${data.chineseName}${data.shortName ? '[' + data.shortName + ']' : ''}`
      }
      return ''
    },
    initCompanyList() {
      const companyList = getFilterCacheList(basicCacheKeys.basic_data_Company, (item) => {
        return Boolean(item.factorySign) || Boolean(item.tradersSign)
      })
      for (const obj of companyList) {
        // 是否为工厂
        if (obj.factorySign) {
          this.factoryCompanyList.push(obj)
        }
        // 是否贸易商
        if (obj.tradersSign) {
          this.tradersSignCompanyList.push(obj)
        }
      }
    }
  }
}
</script>

<style scoped>
.cargo-advance-select-wrapper {
  justify-content: left;
}
</style>
